import { render } from "./Tab.vue?vue&type=template&id=32a8bdef"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/projects/laravel/gs1-ireland/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__